import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import utc from 'dayjs/plugin/utc';
import dayjsBusinessTime from 'dayjs-business-time';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);
dayjs.extend(dayjsBusinessTime);

export const formatDayJsDate = (date: string, storeTimeZone: string) => {
  if (!dayjs(date).isValid()) return '';

  return date?.includes('+')
    ? dayjs(date).tz(storeTimeZone).format('Do MMMM YYYY')
    : dayjs(date).format('Do MMMM YYYY');
};

export const formatDayJsDateShort = (date: string, storeTimeZone: string) => {
  if (!dayjs(date).isValid()) return '';

  return date?.includes('+')
    ? dayjs(date).tz(storeTimeZone).format('Do MMM YYYY')
    : dayjs(date).format('Do MMM YYYY');
};

export const formatDayJsDateTime = (date: string, storeTimeZone: string) => {
  if (!dayjs(date).isValid()) return '';

  return date?.includes('+')
    ? dayjs(date).tz(storeTimeZone).format('D MMM, h:mmA')
    : dayjs(date).format('D MMM, h:mmA');
};
